export const logErrorBoundaryError = (
  error: Error,
  info: { componentStack: string }
) => {
  const ddRum = window.DD_RUM;

  const renderingError = new Error(error.message);
  renderingError.name = `ReactRenderingError`;
  renderingError.stack = info.componentStack;

  ddRum &&
    ddRum.onReady(function () {
      ddRum.addError(renderingError);
    });
};
